import { defineComponent as _defineComponent } from 'vue'
import { Select } from 'ant-design-vue'
import { ref, watch } from 'vue'
import { getFacultyList } from '@/api/web'

type Props = {
  facultyName?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectMajor',
  props: {
    facultyName: null
  },
  emits: ['input'],
  setup(__props: any, { emit }) {

const props = __props as { facultyName?: string };



const majorValue = ref()
const options = ref<{ label: string; value: string }[]>()

watch(
  () => props.facultyName,
  (val) => {
    if (val) {
      loadData()
    } else {
      options.value = undefined
      majorValue.value = undefined
      emit('input', undefined)
    }
  }
)

const loading = ref(false)
function loadData() {
  loading.value = true
  getFacultyList({
    name: props.facultyName,
  })
    .then((response) => {
      const data = response.data[0]
      if (data) {
        options.value = data.major.split(',').map((i) => ({
          label: i,
          value: i,
        }))
      }
    })
    .finally(() => {
      loading.value = false
    })
}


function onChange(val: string) {
  emit('input', val)
}

return { __sfc: true,props, majorValue, options, loading, loadData, emit, onChange, Select }
}

})